<template>
  <form-page-template no-padding :dirty="dirty" @save="doSave">
    <template #toolbar-items>
      <v-toolbar-title class="with-divider">
        サイト実装管理
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
          @click="downloadDockerComposeYaml"
          color="primary">
        <v-icon class="mr-2">mdi-file-key</v-icon>
        サイトの認証ファイルのダウンロード
      </v-btn>
    </template>

    <owner-info
        :account="account">
      <template #append>
        <v-col cols="2">
          <v-text-field
              v-if="isEditable"
              label="ポーリング周期 (秒)"
              v-model="pollingRate"
              :rules="[
                v => !!v || 'ポーリング周期が必要です',
                v => v <= 1000 || 'ポーリング周期は1000以下の値にしてください。',
                v => v >= 10 || 'ポーリング周期は10以上の値にしてください。'
              ]"
              type="number"
              @change="markDirty"
              autofocus>
          </v-text-field>
          <text-field-like
              v-else
              label="ポーリング周期 (秒)"
              :value="pollingRate"
              hide-details>
          </text-field-like>
        </v-col>
      </template>
    </owner-info>

    <template #tab-items>
      <v-tab :to="{name: alterRouteName('./controllers')}">コントローラ</v-tab>
      <v-tab :to="{name: alterRouteName('./calendars')}">カレンダ</v-tab>
    </template>

    <template #after-tabs>
      <router-view></router-view>
    </template>
  </form-page-template>
</template>

<script>
import OwnerInfo from "@/components/organisms/OwnerInfo.vue";
import PathInfoMixin from "@/router/PathInfoMixin";
import IoablePageMixin from "@/router/IoablePageMixin";
import {mapGetters, mapMutations} from "vuex";
import TextFieldLike from "@/components/molecules/TextFieldLike.vue";
import FormPageTemplate from "@/components/templates/FormPageTemplate.vue";
import FileUtils from "@/utils/FileUtils";

export default {
  name: 'TerminalImplementationList',
  components: {
    FormPageTemplate,
    TextFieldLike,
    OwnerInfo,
  },
  mixins: [
    PathInfoMixin,
    IoablePageMixin,
    FileUtils
  ],
  data() {
    return {
      pollingRate: null
    };
  },
  computed: {
    ...mapGetters({
      account: 'hcs/account'
    }),
    terminalId() {
      return this.account.user.terminalId;
    }
  },
  methods: {
    ...mapMutations({
      setLoginUser: 'hcs/setLoginUser',
    }),
    async save() {
      const terminal = await this.$store.dispatch('hcs/terminal/update', {
        id: this.terminalId,
        pollingRate: this.pollingRate
      });
      if (terminal.id === this.terminalId) {
        this.account.user.terminal = terminal;
        this.setLoginUser({loginUser: this.account.user});
      }
    },
    downloadDockerComposeYaml() {
      this.$store.dispatch('hcs/terminal/fetchDockerFile', this.terminalId)
          .then((response) => {
            this.downloadFile(response, 'docker-compose.yml')
          })
          .catch(() => {
            this.$store.commit({
              type: 'showSnackbar',
              color: 'failed',
              message: `認証ファイルのダウンロードに失敗しました`
            });
          })
    }
  },
  watch: {
    'account.user.terminal.pollingRate': {
      immediate: true,
      handler(pollingRate) {
        this.pollingRate = pollingRate;
      }
    }
  }
}
</script>
